<script>
import Multiselect from 'vue-multiselect'
import { timeslotService } from "../../services";
import { required , requiredIf} from "vuelidate/lib/validators";
import config from "../../config";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import "vue2-datepicker/index.css";
import { error_message, success_message } from "../../Helper/helper";
import { minMax } from "../../Helper/formValidation";

export default {
  components: { Multiselect, timeslotService, DatePicker, moment},
    data() {
        return {
            checked: true,
            config: config,
            cust_type_search: {},
            days: [],
            isLoading: false,
            day_type: "",
            del_type: "",
            businessCount: "",
            privateCount: "",
            max: 1,
            typeform: {
                from_time: "",
                to_time: "",
                delivery_type: "1",
                status: "1",
                type: "",
                value: "",
                customer_type: 2,
                cust_type_search:"",
                slectedDays:[],
            },
            allDays:[
                {day:'Monday',driver:1},
                {day:'Tuesday',driver:1},
                {day:'Wednesday',driver:1},
                {day:'Thursday',driver:1},
                {day:'Friday',driver:1},
                {day:'Saturday',driver:1},
                {day:'Sunday',driver:1},
            ] ,
            // options: {
            //     days: [
            //         'Monday',
            //         'Tuesday',
            //         'Wednesday',
            //         'Thursday',
            //         'Friday',
            //         'Saturday',
            //         'Sunday'
            //     ]
            // },
            // slectedDays:[],
        };
    },
    
    validations: {
        typeform: {
            from_time:{
                required,
            },
            to_time:{
                required,
            },
            delivery_type:{
                required,
            },
            type:{
                required,
            },
            cust_type_search: {
                required : requiredIf(function(form){
                    return this.day_type == 1;
                }),
            },
            customer_type:{
                required,
            },
            slectedDays: {
                $each: {
                    day: {
                        required,
                    },
                   
                    driver: {
                        required,
                    },
                },
            },
        }
    },
    mounted(){
        this.driversCount();
    },
    methods: {
        onTypeChange(){

        if(this.typeform.customer_type == 1){
            this.max = this.businessCount;
        }
        else{
            this.max = this.privateCount;
        }
    
            this.typeform.slectedDays = [];
         
            this.typeform.cust_type_search = "";
            this.day_type = this.typeform.type;
            if(this.typeform.type == 0){
                this.typeform.slectedDays = this.allDays;
            }else if(this.typeform.type == '2'){
                //moment().format("YYYY.MM.DD")
                this.typeform.slectedDays = [{day:'Today',driver:1}]
            }
            else{
                this.typeform.slectedDays = this.typeform.slectedDays;
            }
          
        },
        onDayTypeChange(){

            if(this.typeform.customer_type == 1){
                this.max = this.businessCount;
            }
            else{
                this.max = this.privateCount;
            }

            this.typeform.slectedDays = this.typeform.slectedDays;
        
            this.typeform.cust_type_search = this.typeform.slectedDays;
            this.day_type = this.typeform.type;
            if(this.typeform.type == 0){
                this.typeform.slectedDays = this.allDays;
            }else if(this.typeform.type == '2'){
                //moment().format("YYYY.MM.DD")
                this.typeform.slectedDays = [{day:'Today',driver:1}]
            }
            else{
                this.typeform.slectedDays = this.typeform.slectedDays;
            }
  
        },
        onTypeSpecialDay(){
            this.typeform.slectedDays = this.typeform.cust_type_search;
        },
        onDeliveryChange(){
            this.del_type = this.typeform.delivery_type;
        },
        clearAll() {
            this.cust_type_search = {};
        },
        driversCount(){
            timeslotService.driversCount().then((response) => {
               
                    if (response.data.code === 200) {
                        this.businessCount = response.data.result.business;
                        this.privateCount = response.data.result.private;
                        this.max = this.privateCount;
                    } else {
                        // error_message(response.data.message);
                    }
                });
        },
        minMax,
        // contactNumber() {
        //     let val1 = evt.target.value;
        //     if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
        //         evt.preventDefault();
        //     }
        //     let partlen = val1.split("+").length - 1;
        //     if (evt.keyCode == 43 && partlen > 0) {
        //         evt.preventDefault();
        //     } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
        //         evt.preventDefault();
        //     }
        // },
        addTimeSlot(){
            // return false;
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                return;
            } else {
               
                if(this.typeform.to_time == "0:00")
                {
                    this.typeform.to_time = "24:00";
                }    
                timeslotService.addTimeSlot(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "time-slot-list" });
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
        getDisabledStartTime(date){
            var rs = false
            if(this.typeform.to_time!== '' && !rs){
                // if(this.moment(date).isSameOrAfter(this.moment(this.typeform.to_time,'H:mm'))){
                //     rs = true;
                // }
                if(this.moment(date).isSame(this.moment(this.typeform.to_time,'H:mm'))){
                    rs = true;
                }
            }
            return rs;
        },

        getDisabledEndTime(date){
            var rs = false
            if(this.typeform.from_time !== '' && !rs){
                // if(this.moment(date).isSameOrBefore(this.moment(this.typeform.from_time,'H:mm'))){
                //     rs = true;
                // }
                if(this.moment(date).isSame(this.moment(this.typeform.from_time,'H:mm'))){
                    rs = true;
                }
            }
            return rs;
        },
       
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 49 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        limitDriverInput(event, index) {
            // Get the current value from the event target (input field)
            let value = Number(event.target.value);
                console.log(event.target.value);
            // If the value exceeds available_drivers, set it to available_drivers
            if (event.target.value == "") {
                this.typeform.slectedDays[index].driver = "";
            } else {
                if(this.typeform.customer_type == 1){
                    if(value > this.businessCount){
                        this.typeform.slectedDays[index].driver = this.businessCount;
                        event.target.value = this.businessCount;  // Update the input value directly
                    }else {
                        this.typeform.slectedDays[index].driver = value;  // Set the correct value
                    }
                }else{
                    if (value > this.privateCount) {
                        this.typeform.slectedDays[index].driver = this.privateCount;
                        event.target.value = this.privateCount;  // Update the input value directly
                    }else {
                        this.typeform.slectedDays[index].driver = value;  // Set the correct value
                    }
                }
                
            }     
        },
    },
};

</script>
<template>
    <form @submit.prevent="addTimeSlot">
        <div class="card">
            <div class="card-body">
                <p class="card-title-desc"></p>
                <div class="row">

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.From Time')}}</label>
                            <date-picker
                                v-model="typeform.from_time"
                                :time-picker-options="{
                                    start: '00:00',
                                    step: '01:00',
                                    end: '23:00',
                                }"
                                format="H:mm"
                                type="time"
                                class="date-time"
                                placeholder="H:mm"
                                name="from_time"
                                valueType="format"
                                :editable="false"
                                :class="{ 'is-invalid':$v.typeform.from_time.$error }"
                                :disabled-time="function(date){return getDisabledStartTime(date)}"
                            ></date-picker>
                            <div v-if="$v.typeform.from_time.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.from_time.required">{{ trans.get('__JSON__.Please select from time') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.To Time')}}</label>
                            <date-picker
                                v-model="typeform.to_time"
                                :time-picker-options="{
                                    start: '00:00',
                                    step: '01:00',
                                    end: '23:00',
                                }"
                                format="H:mm"
                                type="time"
                                class="date-time"
                                placeholder="H:mm"
                                name="to_time"
                                valueType="format"
                                :editable="false"
                                :class="{ 'is-invalid':$v.typeform.to_time.$error }"
                                :disabled-time="function(date){return getDisabledEndTime(date)}"
                            ></date-picker>
                            <div v-if="$v.typeform.to_time.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.to_time.required">{{ trans.get('__JSON__.Please select to time') }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Delivery Type & Time Slots')}}</label>
                            <select class="custom-select" v-model="$v.typeform.delivery_type.$model" id="delivery_type" name="delivery_type" :class="{ 'is-invalid':$v.typeform.delivery_type.$error }" @change="onDeliveryChange()">
                                <option value="">{{trans.get('__JSON__.Select Delivery Type')}}</option>
                                <option value="0">{{trans.get('__JSON__.Both')}}</option>
                                <option value="1">{{trans.get('__JSON__.Delivery')}}</option>
                                <option value="2">{{trans.get('__JSON__.Pickup')}}</option>
                            </select>
                            <div v-if="$v.typeform.delivery_type.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.delivery_type.required">{{ trans.get('__JSON__.Please select delivery type') }}</span>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="col-sm-6" v-if="this.del_type != 2">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Order Limit')}}</label>
                            <input
                                maxlength="3"
                                minlength="1"
                                id="order_limit"
                                v-model="$v.typeform.order_limit.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Order Limit')"
                                name="order_limit"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.order_limit.$error }"
                            />
                            <div v-if="$v.typeform.order_limit.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.order_limit.required">{{ trans.get('__JSON__.Please enter order limit') }}</span>
                            </div>
                        </div>
                    </div> -->

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Days Selection')}}</label>
                            <select class="custom-select" v-model="$v.typeform.type.$model" id="type" name="type" :class="{ 'is-invalid':$v.typeform.type.$error }" @change="onTypeChange()">
                                <option value="">{{trans.get('__JSON__.Select Days Type')}}</option>
                                <option value="0">{{trans.get('__JSON__.All Days')}}</option>
                                <option value="1">{{trans.get('__JSON__.Special Days')}}</option>
                                <option value="2">{{trans.get('__JSON__.Today')}}</option>
                            </select>
                            <div v-if="$v.typeform.type.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.type.required">{{ trans.get('__JSON__.Please select days type') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="this.day_type == 1">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Days')}}</label>
                            <multiselect 
                                :multiple="true" 
                                v-model="$v.typeform.cust_type_search.$model" 
                                label="day"
                                track-by="day"
                                :options="allDays" 
                                @input="onTypeSpecialDay"
                                :class="{ 'is-invalid': $v.typeform.cust_type_search.$error }"
                            >
                            </multiselect>
                            <div v-if="$v.typeform.cust_type_search.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.cust_type_search.required">{{ trans.get('__JSON__.Please select days') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 vendor-status">
                        <b-form-group
                            id="input-group-2"
                            :label="trans.get('__JSON__.Status')"
                            label-for="Status"
                        >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                            <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="status"
                                            v-model="typeform.status"
                                            true-value="1"
                                            false-value="0"
                                            />
                                            <div class="slider round">
                                                <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                                <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Customer Type')}}</label>
                            <select class="custom-select" v-model="$v.typeform.customer_type.$model" id="type" name="type" :class="{ 'is-invalid':$v.typeform.customer_type.$error }" @change="onDayTypeChange()">
                              
                                <option value="1">Business</option>
                                <option value="2">Private</option>
                            </select>
                            <div v-if="$v.typeform.customer_type.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.customer_type.required">{{ trans.get('__JSON__.Please select Customer Type') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <label>{{ trans.trans('__JSON__.Business Drivers')}}</label>
                        <span>{{businessCount}}</span>
                    </div> 
                    <div class="col-sm-3">
                        <label>{{ trans.trans('__JSON__.Private Drivers')}}</label>
                         <span>{{privateCount}}</span>
                    </div>
                </div>
            
                <div v-if="this.typeform.type != '' && this.typeform.slectedDays.length >0" id="day-driver">
                
                    <h4>
                        {{ trans.get("__JSON__.Add Available Driver") }}
                    </h4>
                    <div class="row" v-for="(v, i) in $v.typeform.slectedDays.$each.$iter" :key="i">
                        <div class="col-md-3">{{v.day.$model}}</div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <input
                                        v-model.number="v.driver.$model"
                                        type="text"
                                        class="form-control"
                                        name="driver[]" 
                                        @keypress="isNumber($event)"
                                        @keyup="limitDriverInput($event, i)"
                                    />
                                    <!-- <input
                                        v-model.number="v.driver.$model"
                                        type="number"
                                        class="form-control"
                                        name="driver[]" 
                                        :max="max"
                                        min=1
                                    /> -->
                                    <!-- @input="() => { if(typeform.customer_type = 1) { value > 0 || value < businessCount }}" -->
                                    <!-- value > 150 || value < 0 -->
                                    <!-- @keyup="handler($event)" -->
                                    <!-- v-on:keyup="minMax($event,1,100)" -->
                                    
                                    <div v-if="v.driver.$error" class="form-error">
                                        <span v-if="!v.driver.required">{{ trans.get('__JSON__.Please add driver number') }}</span>
                                    </div>
                                
                                    <!-- <span class="form-error" v-if="v.driver.$model < 1 || v.driver.$model > 100">Driver number must be between 1 and 100</span> -->
                                    
                                </div>
                            </div>
                    </div>
                
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Time Slot') }}</button>
                        <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                        <router-link
                            :to="{name:'time-slot-list'}"
                        >
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<style>
#day-driver h4{padding: 10px 0px;}
.form-error{font-size: 80%;color: #f46a6a;}
</style>